/**
 * Recursively converts all object keys to lowercase
 * @param {*} data - The data to convert (object, array, or primitive)
 * @returns {*} - The converted data with lowercase keys
 */
export function toLowercaseKeys(data) {
    // Handle null or undefined
    if (data === null || data === undefined) {
      return data;
    }
    
    // Handle arrays - recursively process each element
    if (Array.isArray(data)) {
      return data.map(item => toLowercaseKeys(item));
    }
    
    // Handle objects
    if (typeof data === 'object') {
      const converted = {};
      
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          // Convert key to lowercase and recursively process the value
          const lowercaseKey = key.toLowerCase();
          converted[lowercaseKey] = toLowercaseKeys(data[key]);
        }
      }
      
      return converted;
    }
    
    // Return primitives as-is (string, number, boolean, etc.)
    return data;
  }
  
